/* PROJ-96 Abdruck-Ketten (Fingerabdruck, Handschrift, Hand-/Fussabdruck,
 * Zeichnung) auf ILB22 (Coin) und ILB45 (Herz). Engine = Pfad-Gate +
 * Vorderseiten-SVG + Rueckseiten-Text. GETEILT: byte-identisch in
 * distantlines/assets/ und shared_frontend/ auf dem Render-Server
 * (Parity-Gate tools/jewelry-parity.mjs, Eintrag SHARED).
 *
 * PARITAETS-REGEL (PROJ-67-Muster): Diese Datei liegt MEHRFACH (Theme-Asset,
 * fulfillment-distantlines/shared_frontend/, server-mirror/shared_frontend/
 * und /root/backend-django/shared_frontend/ auf dem Server). Alle Kopien
 * MUESSEN byte-identisch sein, sonst prueft der Server einen anderen Pfad
 * als die Vorschau zeigt. Aenderungen IMMER hier machen und dann kopieren,
 * nie in einer Server-Kopie.
 *
 * Haengt an jewelry-engine.js (muss VORHER geladen sein): nutzt
 * window.jewelryFontDefs (Gravurschrift 'DL Gravur' = Jost Light) fuer die
 * Rueckseite. Fehlt es, liefert die Rueckseite ohne Font-Defs plus
 * console.warn (die Vorschau faellt dann auf 'Jost'/sans-serif zurueck).
 *
 * Klassisches Script, KEINE ES-Imports/-Exports, synchron und DOM-frei
 * (Server-Print-Mode und Theme-Modul laden es gleich).
 *
 * config (Theme: configJson() aus jewelry-abdruck.js; Server: Render-Job
 * aus inhouse_pipeline._lege_render_job_an, form kommt aus der Registry):
 *   { form: 'coin'|'herz', side: 'front'|'back', rueckseite: 'freier Text'|'',
 *     bogen_oben, bogen_unten (V2, Vorderseite, nur Coin, je max 24 Zeichen
 *     aus [0-9A-Za-z .,:·], z. B. '22.04.2025 · 19:05 Uhr' / '3220 g · 52 cm';
 *     Ring mit vier Sektoren (Datum, Uhrzeit, Gewicht, Groesse) und Trennkreisen
 *     auf 12/3/6/9 Uhr, Groesse 112..72, Aussenkante 470),
 *     rueck_modus 'freitext'|'geburt', rueck_name (max 14), rueck_bogen_oben,
 *     rueck_bogen_unten (V2, Rueckseite),
 *     gravur 'flaeche'|'linien' (V3, 13.10.2026: Fingerabdruck als Rillen-
 *     Mittellinien; fehlt = 'flaeche'). Einzige Ausnahme von "nur form, side,
 *     Textfelder": die Engine braucht sie, um den Pfad als Strich statt als
 *     Flaeche auszugeben.
 *     schrift (V5, 20.10.2026): 'modern' (fehlt = 'modern', byte-identisch zu
 *     V4) oder ein Schluessel aus jewelry-abdruck-schriften.js (klassisch,
 *     elegant, schreibschrift, verspielt, handschrift). Gilt fuer Bogen und
 *     Rueckseite. }
 *   Die Engine liest NUR form, side und diese Textfelder. NIE produkt/product: der
 *   Print-Mode kennt nur 'product', das Theme nur 'produkt', und die Engine
 *   darf auf keines von beiden verzweigen.
 *   Der Pfad d ist ein EIGENES Argument (Theme: aus dem Tracer in
 *   jewelry-abdruck-bild.js, Server: per fetch von pfad_url), nie Teil der
 *   config (_config_json traegt nur URLs und Metadaten).
 *
 * GEOMETRIE (viewBox 1024 = 16 mm, 1 Einheit = 0,0156 mm):
 *   - VORNE (gravur 'flaeche'): genau EIN <path> mit absoluten M/L/Z, Integer-Koordinaten,
 *     fill-rule evenodd (Rillen werden zu Loechern), literal fill '#000'
 *     (die 3D-Buehne ersetzt '#000' durch ihre Gravurfarbe), width/height
 *     Pflicht (die Buehne zeichnet per drawImage), String beginnt mit
 *     '<svg ' (2D-Fallback prueft den Praefix), KEIN transform (der
 *     Server-Clipper ueberspringt transform-Teilbaeume) und KEINE <defs>.
 *     Der Erzeuger legt den Pfad schon ins Inset (Kreis r 502, Herz-Kontur
 *     mal 0,98125); die Engine prueft Grammatik, Punkte- und Byte-Cap. Die
 *     Lage prueft der Server-Preflight, im strikt-Modus wird Kappen zum
 *     harten Fehler.
 *   - VORNE (gravur 'linien', V3): derselbe EINE <path>, aber OFFENE Subpfade
 *     `M x y L x y [L x y]*` OHNE Z (Rillen-Mittellinien aus skelett() in
 *     jewelry-abdruck-bild.js), fill 'none', stroke '#000', stroke-width
 *     LINIEN_BREITE 2.4 (= 0,0375 mm, wie die Sternbildlinien; der Server
 *     macht daraus Baender mit zwei Zuegen), runde Enden. Gleiche Caps,
 *     gleiches Inset. pfadOk(d, {gravur: 'linien'}) prueft die Linien-
 *     Grammatik; ohne Option gilt die Flaechen-Grammatik.
 *   - Punkte-Cap MAX_PUNKTE 30000 (Startwert, Spike A1 fixiert ihn): das
 *     Herz-Clipping auf dem Server ist O(N mal K) mit K 256. Byte-Cap
 *     MAX_D_BYTES 600000 = Grenze des Pfad-Uploads.
 *   - HINTEN: freier Text, max. RUECKSEITE_MAX Zeichen, 1 bis 3 Zeilen
 *     (Greedy-Umbruch an Wortgrenzen), Fit-Leiter 1:1 aus
 *     jewelry-letters-engine.js; formabhaengig ist NUR die Fit-Breite
 *     (Coin 820 wie Buchstaben-Coin, Herz 620 wie Herz-Kette, dort gegen
 *     die Kontur nachgerechnet). Harte Mindestgroesse 58 px, was da nicht
 *     passt, lehnt das Gate ab. */
(function (w) {
  'use strict';

  const VERSION = 4;               /* V5-Schriftwahl (20.10.2026); Layout fuer 'modern' unveraendert */
  const MAX_PUNKTE = 30000;
  /* V3 (13.10.2026, Dominik 03.10.: "beste Version bisher"): Fingerabdruck als Linien */
  const GRAVUR_FLAECHE = 'flaeche';
  const GRAVUR_LINIEN = 'linien';
  const GRAVUREN = [GRAVUR_FLAECHE, GRAVUR_LINIEN];
  const LINIEN_BREITE = 2.4;
  const MAX_D_BYTES = 600000;
  const RUECKSEITE_MAX = 60;
  const FIT_BREITE = { coin: 820, herz: 620 };
  /* ---------- Herz-Innenmass (PROJ-116, 24.10.2026: Rueckseiten-Motive auch auf dem Herz) ----------
     Sehnenbreite der kanonischen ILB45-Kontur (jewelry-herz-kontur.js = HERZ_FELD in jewelry-engine.js) um x = 512,
     alle 32 px ab y = 128 bis 928, Werte aus der Kontur gerechnet und hier eingefroren (Kontur aendert sich nur mit
     Neukalibrierung, dann diese Tabelle neu rechnen). Oberhalb y 118 liegt die Kerbe zwischen den Lappen, dort gibt
     es keine durchgehende Sehne; unten laeuft die Spitze bei y 938 aus. HERZ_CY = Flaechenschwerpunkt der Kontur:
     ein Block um diese Mitte bekommt oben und unten gleich viel Luft, am Rand sind die Motive sonst abgeschnitten. */
  const HERZ_SEHNE_Y0 = 128, HERZ_SEHNE_SCHRITT = 32, HERZ_Y_MIN = 118, HERZ_Y_MAX = 938, HERZ_CY = 452;
  const HERZ_SEHNE = [762, 840, 898, 944, 979, 1001, 1015, 1022, 1024, 1021, 1011, 991, 961, 921, 876, 826, 768, 706, 643, 574, 501, 426, 348, 268, 182, 85];
  function herzBreite(y) {
    if (y <= HERZ_Y_MIN || y >= HERZ_Y_MAX) return 0;
    const t = (y - HERZ_SEHNE_Y0) / HERZ_SEHNE_SCHRITT;
    if (t <= 0) return HERZ_SEHNE[0] * (y - HERZ_Y_MIN) / (HERZ_SEHNE_Y0 - HERZ_Y_MIN);
    const i = Math.floor(t);
    const letzt = HERZ_SEHNE.length - 1;
    if (i >= letzt) return HERZ_SEHNE[letzt] * (HERZ_Y_MAX - y) / (HERZ_Y_MAX - (HERZ_SEHNE_Y0 + letzt * HERZ_SEHNE_SCHRITT));
    const f = t - i;
    return HERZ_SEHNE[i] * (1 - f) + HERZ_SEHNE[i + 1] * f;
  }
  /* Achsparalleles Rechteck (Mitte cx/cy, Breite w, Hoehe h) liegt im Herz minus TEXT_RAND: oben und unten
     reicht die Sehne, weil die Breite zwischen den beiden Raendern nie kleiner wird (Kontur ist dort konvex). */
  function herzRechteckPasst(cx, cy, w, h) {
    const yo = cy - h / 2, yu = cy + h / 2;
    if (yo < HERZ_Y_MIN + TEXT_RAND || yu > HERZ_Y_MAX - TEXT_RAND) return false;
    const breite = Math.min(herzBreite(yo), herzBreite(yu)) - 2 * TEXT_RAND;
    return w <= breite && Math.abs(cx - CX) + w / 2 <= CX;
  }
  const FORMEN = ['coin', 'herz'];
  /* V2 (06.09.2026, Vorbild Mizodia "Birth Details"): Geburtsdaten als
     Bogen-Text auf der Vorderseite (nur Coin) und Rueckseiten-Modus
     'geburt' = Name mittig + dieselben Boegen. Bogen-Technik 1:1 aus
     jewelry-birth-engine.js (jedes Zeichen ein eigenes <text> mit
     rotate-Transform, der Server setzt es per Chrome-Messung in Pfade um). */
  const BOGEN_MAX = 24;             /* Zeichen je Bogen, z. B. '22.04.2025 · 19:05 Uhr' = 22 */
  const BOGEN_RE = /^[0-9A-Za-z .,:\u00b7]*$/;   /* Ziffern, Latein, Punkt, Komma, Doppelpunkt, Mittelpunkt */
  /* RING (Dominik 06.09. nachts, Vorbild Mizodia "Birth Details"): vier Sektoren mit
     Datum (oben links), Uhrzeit (oben rechts), Gewicht (unten links), Groesse (unten
     rechts); dazwischen vier gefuellte Kreise (Jost-Bullet U+2022) exakt auf 12, 3, 6 und
     9 Uhr. Der Text laeuft rundherum im Uhrzeigersinn, alle Glyphen mit dem Fuss zur Mitte,
     unten also kopfueber (Dominik 20.10.2026, wie Mizodia und Salome; vorher stand unten
     gegenlaeufig und fuer den Betrachter aufrecht). Aussenkante R_TEXT 470 (0,5 mm Randluft,
     Gravur-Inset liegt bei 502), Groesse so gross wie der laengste Eintrag im Sektor
     (RING_SEKTOR_GRAD) zulaesst: 112 = ~1,25 mm Versal auf 16 mm. */
  const R_TEXT = 470;
  const RING_STUFEN = [112, 108, 104, 100, 96, 92, 88, 84, 80, 76, 72];
  const RING_SEKTOR_GRAD = 84;      /* Textbudget je Viertel (90 Grad minus Luft zu den Kreisen) */
  const RING_SEKTOR_GRAD_SCHRIFT = 78;   /* V5: gewaehlte Schriften (gemessene Breiten, keine Schaetzreserve) brauchen mehr Luft zu den Kreisen */
  const RING_KREIS = '\u2022';     /* Trennkreis: Jost-Bullet (cmap-verifiziert 06.09.), lasert als voller Kreis */
  /* Der Jost-Bullet ist winzig (0,074 em breit, Mitte 0,40 em ueber der Grundlinie, per
     fontTools gemessen 06.09.). Damit ein sichtbarer Kreis von ~0,5 mm entsteht, wird er
     mit RING_KREIS_FAKTOR * Textgroesse gesetzt (112 * 3.9 = 437 -> 32 Einheiten = 0,5 mm)
     und ueber translate(0, 0.40 * Kreisgroesse) radial auf die Textmitte zentriert. */
  const RING_KREIS_FAKTOR = 3.9;
  const RING_KREIS_MITTE_EM = 0.40;
  const RING_KREIS_GRAD = [-90, 0, 90, 180];
  const RING_SEKTOR_MITTE = [-135, -45, 135, 45];   /* Datum, Uhrzeit, Gewicht, Groesse (SVG-Winkel, y nach unten) */
  const NAME_MAX = 14;              /* wie Geburts-Coin */
  const NAME_STUFEN = [96, 86, 76, 66];
  const NAME_MIN = 55;
  const RUECK_MODI = ['freitext', 'geburt'];
  const HERZ_DETAIL_GR = 72;        /* Detailzeilen auf dem Herz (Rueckseite geburt), ~0,8 mm Versal */
  const MOTIVE = ['fingerabdruck', 'handschrift', 'handabdruck', 'fussabdruck', 'zeichnung'];

  const INK = '#000';
  const CX = 512, CY = 512;
  const GRAVUR = "'DL Gravur', 'Jost', sans-serif";
  const VERSAL = 0.72;      /* Versalhoehe Jost Light in em (Schaetzung, wie Buchstaben-Coin) */
  const SVG_KOPF = '<svg xmlns="http://www.w3.org/2000/svg" width="1024" height="1024" viewBox="0 0 1024 1024">';

  function esc(t) {
    return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  function normForm(cfg) {
    return (cfg && cfg.form === 'herz') ? 'herz' : 'coin';
  }

  /* ---------- Schriftwahl (V5, 20.10.2026, Dominik: fuenf bis sechs Schriften) ----------
     'modern' = 'DL Gravur' mit der bisherigen Breiten-Schaetzung (BREITE, GLYPH_EM),
     byte-identisch zu V4. Alle anderen Schluessel kommen aus jewelry-abdruck-schriften.js
     (window.JEWELRY_ABDRUCK_SCHRIFTEN, generiert, gemessene Breiten und Tintenkaesten in
     em). Sie werden auf die optische Groesse der Jost skaliert (skala = HOEHE_JOST / hoehe,
     hoehe = Mittel aus Ziffern- und x-Hoehe): jede Schrift wirkt gleich gross, alle
     Groessenstufen gelten weiter. Den Bogen-Radius rechnet ringRadius() aus den
     Tintenkaesten des konkreten Textes (Schwuenge, Unterlaengen). Die Trennkreise
     im Ring bleiben Jost-Bullets ('DL Gravur'). Der Fallback in der font-family-Liste
     ist die Gravurschrift: laedt eine Face nicht, misst Chrome 'DL Gravur', und der
     Server graviert, was die Vorschau zeigt (Schrift-Register in inhouse_svg). */
  const SCHRIFT_STANDARD = 'modern';
  const SCHRIFT_MODERN = Object.freeze({ key: SCHRIFT_STANDARD, familie: GRAVUR, skala: 1, face: '', breite: glyphBreite, zeichen: null, kasten: null });
  /* Jost Light ('DL Gravur'), per fontTools gemessen 20.10.2026: optische Groesse
     (Ziffern 0,711 + x 0,46) / 2, hoechste Oberkante in [0-9A-Za-z] und Unterlaenge g/j/p/q/y. */
  const HOEHE_JOST = 0.5855;
  const KOPF_JOST = 0.789;
  /* Laser-Sperre (laser_lbrn2, Rand 0,27 mm) erlaubt 7,73 mm = 494,7 Einheiten. Seit alle Glyphen mit
     dem Fuss zur Mitte stehen, zeigen Unterlaengen nach innen; aussen endet jede Schrift wie die Jost
     bei R_TEXT + (KOPF_JOST - VERSAL) * gr (Stufe 112: 477,8 = 7,47 mm). Vorher reichte das g in
     '3480 g' (unten, nach aussen) bis 7,746 mm. */
  const schriftCache = {};
  function schriftVon(schrift) {
    const k = schrift == null || schrift === '' ? SCHRIFT_STANDARD : String(schrift);
    if (k === SCHRIFT_STANDARD) return SCHRIFT_MODERN;
    if (Object.prototype.hasOwnProperty.call(schriftCache, k)) return schriftCache[k];
    const tab = w.JEWELRY_ABDRUCK_SCHRIFTEN;
    const S = tab && Object.prototype.hasOwnProperty.call(tab, k) ? tab[k] : null;
    if (!S) throw new Error('jewelryAbdruck: schrift ' + JSON.stringify(k) + ' unbekannt (oder jewelry-abdruck-schriften.js nicht geladen)');
    const skala = HOEHE_JOST / S.hoehe;
    const o = Object.freeze({
      key: k,
      familie: "'" + S.familie + "', " + GRAVUR,
      skala,
      face: "@font-face{font-family:'" + S.familie + "';src:url(data:font/woff2;base64," + S.woff2 + ") format('woff2');font-weight:400;font-style:normal;}",
      breite: (ch) => (S.breiten[ch] != null ? S.breiten[ch] : 0.6) * skala,
      zeichen: S.breiten,
      kasten: S.kasten,
    });
    schriftCache[k] = o;
    return o;
  }
  function schriftOk(schrift) {
    try { schriftVon(schrift); return true; } catch (e) { return false; }
  }
  /* true = jedes Zeichen hat eine Glyphe in der gewaehlten Schrift. 'modern' prueft wie
     bisher der Aufrufer (Jost-cmap im Theme, Server-Gate), hier immer true. */
  function textInSchrift(t, sch) {
    if (!sch.zeichen) return true;
    for (const ch of t) if (sch.zeichen[ch] == null) return false;
    return true;
  }
  /* font-size: bei 'modern' die Stufe selbst (Integer, wie V4), sonst skaliert. */
  function groesseAttr(gr, sch) {
    return sch.skala === 1 ? gr : +(gr * sch.skala).toFixed(1);
  }
  function breiteIn(t, gr, sch) {
    let b = 0;
    for (const ch of t) b += sch.breite(ch) * gr;
    return b;
  }
  /* Defs einer Seite: 'modern' genau wie V4; sonst die Face der Schrift, plus die
     Gravurschrift, wenn Trennkreise (Ring) auf der Seite stehen. */
  function schriftDefs(sch, mitRing) {
    if (!sch.face) return fontDefs();
    return (mitRing ? fontDefs() : '') + '<defs><style>' + sch.face + '</style></defs>';
  }

  function fontDefs() {
    if (typeof w.jewelryFontDefs === 'function') return w.jewelryFontDefs();
    if (typeof console !== 'undefined' && console && typeof console.warn === 'function')
      console.warn('jewelry-abdruck-engine: window.jewelryFontDefs fehlt (jewelry-engine.js vorher laden), Rueckseite ohne Font-Defs');
    return '';
  }

  /* ---------- Bogen-Text (1:1 Geburts-Coin) ---------- */
  const BREITE = {
    ' ': 0.26, '.': 0.24, ',': 0.24, '-': 0.33, "'": 0.2, '’': 0.2,
    'i': 0.24, 'l': 0.24, 'j': 0.25, 'f': 0.3, 't': 0.32, 'r': 0.34, 'í': 0.24, 'ì': 0.24, 'ł': 0.28,
    'm': 0.8, 'w': 0.74, 'W': 0.92, 'M': 0.84, 'I': 0.25, 'J': 0.4, 'L': 0.48,
    'a': 0.52, 'c': 0.48, 'e': 0.54, 'o': 0.58, 's': 0.44, 'z': 0.46, 'x': 0.5, 'v': 0.5, 'y': 0.5, 'k': 0.5,
    'n': 0.58, 'u': 0.58, 'h': 0.58, 'b': 0.58, 'd': 0.58, 'p': 0.58, 'q': 0.58, 'g': 0.58,
    'A': 0.66, 'B': 0.6, 'C': 0.66, 'D': 0.7, 'E': 0.52, 'F': 0.52, 'G': 0.74, 'H': 0.72, 'K': 0.62,
    'N': 0.74, 'O': 0.78, 'P': 0.6, 'Q': 0.78, 'R': 0.62, 'S': 0.54, 'T': 0.54, 'U': 0.7, 'V': 0.68,
    'X': 0.64, 'Y': 0.6, 'Z': 0.6,
    '0': 0.6, '1': 0.42, '2': 0.56, '3': 0.56, '4': 0.6, '5': 0.56, '6': 0.58, '7': 0.52, '8': 0.58, '9': 0.58
  };
  function glyphBreite(ch) {
    if (BREITE[ch] != null) return BREITE[ch];
    const basis = ch.normalize('NFD')[0];
    if (BREITE[basis] != null) return BREITE[basis];
    return /[A-ZÀ-ÞĄĆĘŁŃŚŹŻА-ЯЁ]/.test(ch) ? 0.68 : 0.55;
  }
  function textBreite(t, gr) {
    let b = 0;
    for (const ch of t) b += glyphBreite(ch) * gr;
    return b;
  }



  /* Bogen-Text: Zeichen gleichmaessig um den Scheitel verteilt.
     oben=true: Scheitel bei -90 Grad (12 Uhr), Glyphen stehen aufrecht
     mit dem Fuss zur Mitte. oben=false: Scheitel bei +90 Grad (6 Uhr),
     Glyphen mit dem Kopf zur Mitte (aufrecht fuer den Betrachter). */

  /* Eintraege des Rings: bogen_oben = 'Datum · Uhrzeit', bogen_unten = 'Gewicht · Groesse'
     (der Wizard trennt mit ' · '). Fehlende Eintraege lassen ihren Sektor leer. */
  function ringEintraege(oben, unten) {
    const teile = t => bogenNorm(t).split(' \u00b7 ').map(x => x.trim()).filter(Boolean).slice(0, 2);
    const o = teile(oben), u = teile(unten);
    return [o[0] || '', o[1] || '', u[0] || '', u[1] || ''];
  }
  /* Grundlinien-Radius des Rings (eine Grundlinie fuer alle vier Eintraege, Fuss zur Mitte).
     'modern' wie V4 oben: R_TEXT - Versal. Andere Schriften: die hoechste Oberkante aller
     Eintraege endet dort, wo die Jost schlimmstenfalls endet (R_TEXT + (KOPF_JOST - VERSAL) * gr). */
  function ringRadius(eintraege, gr, sch) {
    if (!sch.kasten) return R_TEXT - gr * VERSAL;
    let m = 0;
    for (const t of eintraege) for (const ch of t) {
      const k = sch.kasten[ch];
      if (k) m = Math.max(m, k[1]);
    }
    const kopf = m * sch.skala * gr || VERSAL * gr;
    return R_TEXT + (KOPF_JOST - VERSAL) * gr - kopf;
  }
  /* Groesse: groesste Stufe, bei der JEDER Eintrag in sein Viertel passt. */
  function ringGroesse(eintraege, sch) {
    const sc = sch || SCHRIFT_MODERN;
    for (const gr of RING_STUFEN) {
      let passt = true;
      const r = ringRadius(eintraege, gr, sc);
      for (let i = 0; i < 4; i++) {
        const t = eintraege[i];
        if (!t) continue;
        if (breiteIn(t, gr, sc) > r * (sc.kasten ? RING_SEKTOR_GRAD_SCHRIFT : RING_SEKTOR_GRAD) * Math.PI / 180) { passt = false; break; }
      }
      if (passt) return gr;
    }
    return null;
  }
  function ringTextVon(oben, unten) {
    return ringEintraege(oben, unten).filter(Boolean).join(' \u00b7 ');
  }
  function bogenNorm(t) {
    return (t == null ? '' : String(t)).trim().replace(/\s+/g, ' ');
  }
  function bogenOk(t) {
    const n = bogenNorm(t);
    return n === '' || (BOGEN_RE.test(n) && [...n].length <= BOGEN_MAX);
  }
  /* true = Text ueberschreitet Whitelist/Laenge oder passt selbst in der
     kleinsten Stufe nicht auf den Bogen (oben 140 Grad, unten 110 Grad). */
  function bogenZuLang(t, oben, schrift) {
    const n = bogenNorm(t);
    if (!n) return false;
    if (!bogenOk(n) || !schriftOk(schrift)) return true;
    const sch = schriftVon(schrift);
    if (!textInSchrift(n, sch)) return true;
    return ringGroesse(oben === false ? ringEintraege('', n) : ringEintraege(n, ''), sch) == null;
  }
  /* true = ein Eintrag passt selbst in der kleinsten Stufe nicht in sein Viertel
     (schrift optional, fehlt = 'modern'). */
  function ringZuLang(oben, unten, schrift) {
    if (!bogenOk(oben) || !bogenOk(unten) || !schriftOk(schrift)) return true;
    const sch = schriftVon(schrift);
    if (!textInSchrift(bogenNorm(oben) + bogenNorm(unten), sch)) return true;
    const e = ringEintraege(oben, unten);
    return e.some(Boolean) && ringGroesse(e, sch) == null;
  }
  /* Ein Eintrag als Bogen um seinen Sektor-Mittelwinkel, im Uhrzeigersinn, Fuss zur Mitte. */
  function sektorText(t, gr, mitteGrad, sch, r) {
    const zeichen = [...t];
    const breiten = zeichen.map((ch) => sch.breite(ch) * gr);
    const gesamt = breiten.reduce((a, b) => a + b, 0);
    let lauf = -gesamt / 2;
    let s = '';
    for (let i = 0; i < zeichen.length; i++) {
      const mitteBogen = lauf + breiten[i] / 2;
      lauf += breiten[i];
      if (zeichen[i] === ' ') continue;
      const deg = (mitteBogen / r) * 180 / Math.PI;
      const winkel = mitteGrad + deg;
      const rad = winkel * Math.PI / 180;
      const x = CX + r * Math.cos(rad), y = CY + r * Math.sin(rad);
      const rot = winkel + 90;
      s += `<text x="${x.toFixed(1)}" y="${y.toFixed(1)}" transform="rotate(${rot.toFixed(2)} ${x.toFixed(1)} ${y.toFixed(1)})" font-family="${sch.familie}" font-size="${groesseAttr(gr, sch)}" text-anchor="middle" fill="${INK}">${esc(zeichen[i])}</text>`;
    }
    return s;
  }
  /* Vier Trennkreise auf 12/3/6/9 Uhr, optisch auf der Textmitte des Rings. */
  function ringKreise(gr, r0, sch) {
    /* auf halber Ziffernhoehe ueber der Grundlinie ('modern' wie V4: R_TEXT - Versal / 2) */
    const k0 = sch.kasten && sch.kasten['0'];
    const r = r0 + (k0 ? k0[1] * sch.skala : VERSAL) * gr / 2;
    const kgr = Math.round(gr * RING_KREIS_FAKTOR);
    let s = '';
    for (const g of RING_KREIS_GRAD) {
      const rad = g * Math.PI / 180;
      const x = CX + r * Math.cos(rad), y = CY + r * Math.sin(rad);
      /* Kreismitte auf (x, y): Grundlinie um 0,40 em der Kreisgroesse nach innen */
      s += `<text x="${x.toFixed(1)}" y="${y.toFixed(1)}" transform="rotate(${(g + 90).toFixed(2)} ${x.toFixed(1)} ${y.toFixed(1)}) translate(0 ${(kgr * RING_KREIS_MITTE_EM).toFixed(1)})" font-family="${GRAVUR}" font-size="${kgr}" text-anchor="middle" fill="${INK}">${RING_KREIS}</text>`;
    }
    return s;
  }
  function ringText(oben, unten, sch) {
    const e = ringEintraege(oben, unten);
    if (!e.some(Boolean)) return '';
    const gr = ringGroesse(e, sch);
    if (gr == null) throw new Error('jewelry-abdruck-engine: Ringtext zu lang, vorher jewelryAbdruckRingZuLang aufrufen');
    const r = ringRadius(e, gr, sch);
    let s = ringKreise(gr, r, sch);
    for (let i = 0; i < 4; i++) if (e[i]) s += sektorText(e[i], gr, RING_SEKTOR_MITTE[i], sch, r);
    return s;
  }
  /* Bogen-Text: Zeichen gleichmaessig um den Scheitel verteilt (Geburts-Coin).
     oben=true: Scheitel bei 12 Uhr, Glyphen aufrecht mit dem Fuss zur Mitte;
     oben=false: Scheitel bei 6 Uhr, Glyphen mit dem Kopf zur Mitte. */
  function bogenText(t, gr, oben) {
    const zeichen = [...t];
    const breiten = zeichen.map((ch) => glyphBreite(ch) * gr);
    const gesamt = breiten.reduce((a, b) => a + b, 0);
    const r = oben ? R_TEXT - gr * VERSAL : R_TEXT;
    let lauf = -gesamt / 2;
    let s = '';
    for (let i = 0; i < zeichen.length; i++) {
      const mitteBogen = lauf + breiten[i] / 2;
      lauf += breiten[i];
      if (zeichen[i] === ' ') continue;
      const deg = (mitteBogen / r) * 180 / Math.PI;
      const winkel = oben ? -90 + deg : 90 - deg;
      const rad = winkel * Math.PI / 180;
      const x = CX + r * Math.cos(rad), y = CY + r * Math.sin(rad);
      const rot = oben ? winkel + 90 : winkel - 90;
      s += `<text x="${x.toFixed(1)}" y="${y.toFixed(1)}" transform="rotate(${rot.toFixed(2)} ${x.toFixed(1)} ${y.toFixed(1)})" font-family="${GRAVUR}" font-size="${gr}" text-anchor="middle" fill="${INK}">${esc(zeichen[i])}</text>`;
    }
    return s;
  }
  /* Beide Boegen einer Seite (oben/unten) als SVG-Fragment; wirft bei
     Zeichen ausserhalb der Whitelist (Sicherheitsnetz, Gate vorher). */
  function boegen(cfgOben, cfgUnten, sch) {
    const o = bogenNorm(cfgOben), u = bogenNorm(cfgUnten);
    if (!o && !u) return '';
    const sc = sch || SCHRIFT_MODERN;
    if (!bogenOk(o) || !bogenOk(u) || !textInSchrift(o + u, sc)) throw new Error('jewelry-abdruck-engine: Bogen-Text ungueltig, vorher jewelryAbdruckRingZuLang aufrufen');
    return ringText(o, u, sc);
  }

  /* ---------- Pfad-Gate ---------- */
  /* Grammatik (strikt, identisch im Theme vor dem Upload und im Print-Mode
     nach dem fetch):
       d       = Subpfad (' ' Subpfad)*
       Subpfad = 'M' x y ('L' x y){2,} 'Z'
       Token durch GENAU EIN Leerzeichen getrennt; x, y = Integer 0..1024
       ohne Vorzeichen, ohne Nachkommastellen, ohne fuehrende Null (ausser
       der Zahl 0 selbst). Kein anderes Zeichen: kein Komma, kein
       Zeilenumbruch, keine Kurven, keine relativen Befehle. */
  const ZEICHEN_RE = /^[MLZ0-9 ]+$/;
  const KOORD_RE = /^(?:0|[1-9][0-9]{0,2}|10[01][0-9]|102[0-4])$/;

  function utf8Bytes(s) {
    let n = 0;
    for (let i = 0; i < s.length; i++) {
      const c = s.charCodeAt(i);
      if (c < 0x80) n += 1;
      else if (c < 0x800) n += 2;
      else if (c >= 0xd800 && c <= 0xdbff) { n += 4; i++; }
      else n += 3;
    }
    return n;
  }

  function gravurNorm(cfg) {
    const g = cfg && cfg.gravur != null && cfg.gravur !== '' ? cfg.gravur : GRAVUR_FLAECHE;
    if (GRAVUREN.indexOf(g) < 0) throw new Error('jewelryAbdruck: gravur ' + JSON.stringify(g) + ' unbekannt (flaeche|linien)');
    return g;
  }

  /* opts.gravur 'linien': offene Subpfade M x y L x y [L x y]* ohne Z (mindestens ein L je
     Subpfad). Sonst die Flaechen-Grammatik (Z nach mindestens zwei L). */
  function pfadOk(d, opts) {
    if (typeof d !== 'string' || d.length === 0)
      return { ok: false, punkte: 0, bytes: 0, fehler: 'Pfad ist leer' };
    if (gravurNorm(opts) === GRAVUR_LINIEN) return linienPfadOk(d);
    /* UTF-16-Laenge ist nie groesser als die UTF-8-Bytezahl: wer hier schon
       drueber liegt, ist sicher zu gross. Erst danach die (lineare)
       Grammatik-Pruefung, damit Riesen-Uploads billig abgewiesen werden. */
    if (d.length > MAX_D_BYTES) {
      const bytes = utf8Bytes(d);
      return { ok: false, punkte: 0, bytes, fehler: 'Pfad zu gross: ' + bytes + ' Bytes (max ' + MAX_D_BYTES + ')' };
    }
    if (!ZEICHEN_RE.test(d))
      return { ok: false, punkte: 0, bytes: utf8Bytes(d), fehler: 'Pfad-Grammatik verletzt: nur M, L, Z, Ziffern und einfache Leerzeichen erlaubt' };
    /* Nach der Whitelist ist der String reines ASCII: Bytes = Laenge. */
    const bytes = d.length;
    if (bytes > MAX_D_BYTES)
      return { ok: false, punkte: 0, bytes, fehler: 'Pfad zu gross: ' + bytes + ' Bytes (max ' + MAX_D_BYTES + ')' };

    const tok = d.split(' ');
    const n = tok.length;
    let punkte = 0;
    /* Zustand: 0 = M erwartet, 1 = L erwartet (noch keine 2 L im Subpfad),
       2 = L oder Z erwartet, 3 = nach Z (M oder Ende erwartet). */
    let zustand = 0;
    let lZahl = 0;
    const fehl = (i, was) => ({
      ok: false, punkte, bytes,
      fehler: 'Pfad-Grammatik verletzt bei Token ' + i + ' ("' + (i < n ? tok[i] : '') + '"): ' + was,
    });
    let i = 0;
    while (i < n) {
      const t = tok[i];
      if (t === 'M') {
        if (zustand !== 0 && zustand !== 3) return fehl(i, 'M nur am Anfang eines Subpfads (vorheriger Subpfad ohne Z)');
        if (!KOORD_RE.test(tok[i + 1]) || !KOORD_RE.test(tok[i + 2])) return fehl(i + 1, 'x y als Integer 0..1024 erwartet');
        i += 3; punkte++; lZahl = 0; zustand = 1;
      } else if (t === 'L') {
        if (zustand !== 1 && zustand !== 2) return fehl(i, 'L ohne vorheriges M');
        if (!KOORD_RE.test(tok[i + 1]) || !KOORD_RE.test(tok[i + 2])) return fehl(i + 1, 'x y als Integer 0..1024 erwartet');
        i += 3; punkte++; lZahl++; zustand = lZahl >= 2 ? 2 : 1;
      } else if (t === 'Z') {
        if (zustand !== 2) return fehl(i, 'Z erst nach mindestens 2 L je Subpfad');
        i += 1; zustand = 3;
      } else if (t === '') {
        return fehl(i, 'leeres Token (doppeltes Leerzeichen oder Leerzeichen am Rand)');
      } else {
        return fehl(i, 'nur M, L, Z erlaubt');
      }
    }
    if (zustand !== 3) return fehl(n, 'Pfad muss mit Z enden');
    if (punkte > MAX_PUNKTE)
      return { ok: false, punkte, bytes, fehler: 'Zu viele Punkte: ' + punkte + ' (max ' + MAX_PUNKTE + ')' };
    return { ok: true, punkte, bytes, fehler: null };
  }

  function linienPfadOk(d) {
    if (d.length > MAX_D_BYTES) {
      const bytes = utf8Bytes(d);
      return { ok: false, punkte: 0, bytes, fehler: 'Pfad zu gross: ' + bytes + ' Bytes (max ' + MAX_D_BYTES + ')' };
    }
    if (!ZEICHEN_RE.test(d) || d.indexOf('Z') >= 0)
      return { ok: false, punkte: 0, bytes: utf8Bytes(d), fehler: 'Linien-Grammatik verletzt: nur M, L, Ziffern und einfache Leerzeichen erlaubt (kein Z)' };
    const bytes = d.length;
    const tok = d.split(' ');
    const n = tok.length;
    let punkte = 0;
    /* Zustand: 0 = M erwartet, 1 = L erwartet (Subpfad hat noch kein L), 2 = L oder M oder Ende erwartet. */
    let zustand = 0;
    const fehl = (i, was) => ({
      ok: false, punkte, bytes,
      fehler: 'Linien-Grammatik verletzt bei Token ' + i + ' ("' + (i < n ? tok[i] : '') + '"): ' + was,
    });
    let i = 0;
    while (i < n) {
      const t = tok[i];
      if (t === 'M') {
        if (zustand !== 0 && zustand !== 2) return fehl(i, 'M nur am Anfang eines Subpfads (vorheriger Subpfad ohne L)');
        if (!KOORD_RE.test(tok[i + 1]) || !KOORD_RE.test(tok[i + 2])) return fehl(i + 1, 'x y als Integer 0..1024 erwartet');
        i += 3; punkte++; zustand = 1;
      } else if (t === 'L') {
        if (zustand !== 1 && zustand !== 2) return fehl(i, 'L ohne vorheriges M');
        if (!KOORD_RE.test(tok[i + 1]) || !KOORD_RE.test(tok[i + 2])) return fehl(i + 1, 'x y als Integer 0..1024 erwartet');
        i += 3; punkte++; zustand = 2;
      } else if (t === '') {
        return fehl(i, 'leeres Token (doppeltes Leerzeichen oder Leerzeichen am Rand)');
      } else {
        return fehl(i, 'nur M und L erlaubt');
      }
    }
    if (zustand !== 2) return fehl(n, 'jeder Subpfad braucht mindestens ein L');
    if (punkte > MAX_PUNKTE)
      return { ok: false, punkte, bytes, fehler: 'Zu viele Punkte: ' + punkte + ' (max ' + MAX_PUNKTE + ')' };
    return { ok: true, punkte, bytes, fehler: null };
  }

  /* ---------- Vorderseite: der Pfad, sonst nichts ---------- */
  /* cfg wird hier bewusst nicht gelesen: Coin und Herz teilen dieselbe
     Vorderseite, die Form steckt im Pfad (Inset durch den Erzeuger). Der
     Aufrufer MUSS d vorher durch pfadOk schicken; als Sicherheitsnetz
     wirft die Engine bei Zeichen ausserhalb der Whitelist, statt still
     einen leeren Coin zu liefern. */
  function frontSVG(cfg, d) {
    /* V2: Bogen-Text nur auf dem Coin (Herz-Kontur traegt keinen Ring);
       mit Text kommen die Font-Defs mit. Pfad leer + Boegen = nur Boegen
       (Print-Mode setzt das synchron VOR dem fetch, damit die Inline-Face
       vor fontsReady im DOM steht; Buehne zeigt so die Boegen ohne Foto). */
    const mitBogen = normForm(cfg) === 'coin' && cfg && (bogenNorm(cfg.bogen_oben) || bogenNorm(cfg.bogen_unten));
    const linien = gravurNorm(cfg) === GRAVUR_LINIEN;
    const sch = schriftVon(cfg && cfg.schrift);
    let s = SVG_KOPF;
    if (mitBogen) s += schriftDefs(sch, true);
    if (d != null && d !== '') {
      if (typeof d !== 'string' || !ZEICHEN_RE.test(d))
        throw new Error('jewelryAbdruckFrontSVG: ungueltiger Pfad, vorher jewelryAbdruckPfadOk aufrufen');
      s += linien
        ? '<path d="' + d + '" fill="none" stroke="' + INK + '" stroke-width="' + LINIEN_BREITE + '" stroke-linecap="round" stroke-linejoin="round"/>'
        : '<path d="' + d + '" fill="' + INK + '" fill-rule="evenodd"/>';
    }
    if (mitBogen) s += boegen(cfg.bogen_oben, cfg.bogen_unten, sch);
    return s + '</svg>';
  }

  /* ---------- Rueckseite: freier Text, 1-3 Zeilen ---------- */
  /* Logik 1:1 aus jewelry-letters-engine.js (Buchstaben-Coin) bzw.
     jewelry-herz-engine.js (Herz-Kette); formabhaengig ist NUR die
     Fit-Breite. Wer hier etwas aendert, muss dort dasselbe aendern, sonst
     driften die Rueckseiten der Linie auseinander. */
  const RUECK_STUFEN = [84, 74, 66, 58];
  const RUECK_MIN = 58;
  const RUECK_ZEILEN_MAX = 3;
  const GLYPH_EM = 0.55;
  const ZEILE_EM = 1.35;    /* Zeilenabstand in em */

  function effLaenge(t) {
    let n = 0;
    for (const ch of t) n += /[A-ZÀ-ÞĄĆĘŁŃŚŹŻА-ЯЁ]/.test(ch) ? 1.3 : 1;
    return n;
  }
  /* 'modern' (sch fehlt oder SCHRIFT_MODERN): Schaetzung wie V4; sonst gemessene Breiten. */
  const zeilePasst = (t, gr, fit, sch) => (!sch || sch === SCHRIFT_MODERN
    ? effLaenge(t) * gr * GLYPH_EM <= fit
    : breiteIn(t, gr, sch) <= fit);

  /* Greedy-Umbruch an Wortgrenzen fuer eine feste Groesse; null wenn ein
     Einzelwort nicht passt oder mehr als RUECK_ZEILEN_MAX Zeilen noetig. */
  function umbruch(text, gr, fit, sch) {
    const worte = text.split(/\s+/).filter(Boolean);
    const zeilen = [];
    let akt = '';
    for (const wort of worte) {
      if (!zeilePasst(wort, gr, fit, sch)) return null;
      const test = akt ? akt + ' ' + wort : wort;
      if (zeilePasst(test, gr, fit, sch)) akt = test;
      else { zeilen.push(akt); akt = wort; }
    }
    if (akt) zeilen.push(akt);
    return zeilen.length <= RUECK_ZEILEN_MAX ? zeilen : null;
  }

  /* Groesste Stufe, bei der der Text in max. 3 Zeilen passt. null = zu
     lang. Die kleinste Stufe ist RUECK_MIN (58 px, ca. 0,65 mm Versal). */
  function rueckLayout(text, fit, sch) {
    for (const gr of RUECK_STUFEN) {
      const zeilen = umbruch(text, gr, fit, sch);
      if (zeilen) return { gr, zeilen };
    }
    return null;
  }

  function normText(text) {
    return (text || '').trim().replace(/\s+/g, ' ');
  }

  function rueckseiteZuLang(text, form, schrift) {
    const t = normText(text);
    if (!t) return false;
    if ([...t].length > RUECKSEITE_MAX || !schriftOk(schrift)) return true;
    const sch = schriftVon(schrift);
    if (!textInSchrift(t, sch)) return true;
    return rueckLayout(t, FIT_BREITE[form === 'herz' ? 'herz' : 'coin'], sch) == null;
  }

  /* ---------- Rueckseite Modus 'geburt': Name mittig + Boegen (Coin) ---------- */
  function nameNorm(name) {
    return normText(name);
  }
  function nameGroesse(name, fit, sch) {
    for (const gr of NAME_STUFEN) if (zeilePasst(name, gr, fit, sch)) return gr;
    return null;
  }
  function nameZuLang(name, form, schrift) {
    const n = nameNorm(name);
    if (!n) return false;
    if ([...n].length > NAME_MAX || !schriftOk(schrift)) return true;
    const sch = schriftVon(schrift);
    if (!textInSchrift(n, sch)) return true;
    return nameGroesse(n, FIT_BREITE[form === 'herz' ? 'herz' : 'coin'], sch) == null;
  }
  function zeile(text, gr, yMitte, sch) {
    const sc = sch || SCHRIFT_MODERN;
    const y = yMitte + gr * VERSAL / 2;
    return `<text x="${CX}" y="${y.toFixed(1)}" font-family="${sc.familie}" font-size="${groesseAttr(gr, sc)}" text-anchor="middle" fill="${INK}">${esc(text)}</text>`;
  }
  function backGeburt(cfg, form, sch) {
    const fit = FIT_BREITE[form];
    const name = nameNorm(cfg.rueck_name);
    const o = bogenNorm(cfg.rueck_bogen_oben), u = bogenNorm(cfg.rueck_bogen_unten);
    let s = '';
    if (form === 'coin') {
      if (name) {
        if (!textInSchrift(name, sch)) throw new Error('jewelry-abdruck-engine: Name mit Zeichen ausserhalb der Schrift');
        const gr = nameGroesse(name, fit, sch);
        if (gr == null) throw new Error('jewelry-abdruck-engine: Name zu lang, vorher jewelryAbdruckNameZuLang aufrufen');
        s += zeile(name, gr, CY, sch);
      }
      s += boegen(o, u, sch);
      return s;
    }
    /* Herz: gerade Zeilen statt Boegen (Name groesser, darunter die
       Details). Jeder Bogen-Text wird am Mittelpunkt ' · ' in eigene Zeilen
       geteilt ('22.04.2025' / '19:05 Uhr' / '3220 g' / '52 cm'), weil eine
       22-Zeichen-Zeile bei 58 px die Herz-Fit-Breite 620 sprengt. Block auf
       der Herz-Mitte, Detailzeilen fest HERZ_DETAIL_GR. */
    const zeilen = [];
    if (name) {
      if (!textInSchrift(name, sch)) throw new Error('jewelry-abdruck-engine: Name mit Zeichen ausserhalb der Schrift');
      const gr = nameGroesse(name, fit, sch);
      if (gr == null) throw new Error('jewelry-abdruck-engine: Name zu lang, vorher jewelryAbdruckNameZuLang aufrufen');
      zeilen.push({ t: name, gr });
    }
    for (const t of [o, u]) {
      if (!t) continue;
      if (!bogenOk(t)) throw new Error('jewelry-abdruck-engine: Bogen-Text ungueltig, vorher jewelryAbdruckBogenZuLang aufrufen');
      for (const teil of t.split(' \u00b7 ')) {
        const z = teil.trim();
        if (!z) continue;
        let gr = null;
        for (const g of [HERZ_DETAIL_GR, RUECK_MIN]) if (zeilePasst(z, g, fit, sch)) { gr = g; break; }
        if (gr == null) throw new Error('jewelry-abdruck-engine: Detailzeile zu lang fuer das Herz');
        zeilen.push({ t: z, gr });
      }
    }
    const hoehen = zeilen.map(z => z.gr * ZEILE_EM);
    const gesamt = hoehen.reduce((a, b) => a + b, 0);
    let y = CY - gesamt / 2;
    for (let i = 0; i < zeilen.length; i++) {
      s += zeile(zeilen[i].t, zeilen[i].gr, y + hoehen[i] / 2, sch);
      y += hoehen[i];
    }
    return s;
  }

  /* ---------- V6 (20.10.2026): Rueckseiten-Motive (Fussabdruck-PDP, Dominik 20.10.: "Rueckseite optional
     gestaltbar", Vorbild Mizodia/gravurschmuck.de, ohne Aufpreis) ----------
     rueck_motiv 'keine'|'text'|'handschrift'|'fingerabdruck'|'blume'|'sternenhimmel'|'koordinaten'. Fehlt
     rueck_motiv, gilt das alte Verhalten (rueck_modus freitext/geburt), byte-identisch zu V5. Seit 24.10.2026 (PROJ-116)
     auch auf dem Herz (HERZ_SEHNE/HERZ_CY, Blume contain-gefittet, Sternenhimmel/Pfad mit form). Coin: alle
     Motive liegen im selben 1024er-viewBox des ILB22 wie ihre Schwester-Ketten und werden 1:1 von deren
     Engines gezeichnet, die VORHER geladen sein muessen:
       blume          -> jewelry-blumen-engine.js + jewelry-blumen-motive.js (rueck_monat 1..12, rueck_blume)
       sternenhimmel  -> jewelry-engine.js, Sterne/Linien als Argument extra.sterne/extra.linien; Ort rueck_ort
                         {name, lat, lon}, Datum und Uhrzeit aus geburt {datum, zeit} (Stil klassisch wie die Kette)
       koordinaten    -> jewelryKoordText aus jewelry-engine.js, zwei Zeilen (Breite, Laenge) in der gewaehlten Schrift
       handschrift, fingerabdruck -> Pfad extra.d wie vorne (frontSVG ohne Ring), Gravurart rueck_gravur
     Ohne Pfad (Foto kommt spaeter) bleibt die Rueckseite leer; der Server wartet dann auf den Pfad. */
  const RUECK_MOTIVE = ['keine', 'text', 'handschrift', 'fingerabdruck', 'blume', 'sternenhimmel', 'koordinaten'];
  const RUECK_MOTIVE_PFAD = ['handschrift', 'fingerabdruck'];
  const KOORD_STUFEN = [120, 108, 96, 84];
  const SVG_LEER = SVG_KOPF + '</svg>';
  function rueckMotivVon(cfg) {
    const m = cfg && cfg.rueck_motiv;
    if (m == null || m === '') return null;
    if (RUECK_MOTIVE.indexOf(m) < 0) throw new Error('jewelryAbdruck: rueck_motiv ' + JSON.stringify(m) + ' unbekannt');
    return m;
  }
  function koordZeilen(ort) {
    if (typeof w.jewelryKoordText !== 'function') throw new Error('jewelryAbdruck: jewelryKoordText fehlt (jewelry-engine.js vorher laden)');
    return w.jewelryKoordText({ ort }).split(' \u00b7 ');
  }
  /* Schrift der Koordinaten: die gewaehlte, wenn sie Grad- und Minutenzeichen hat, sonst die Gravurschrift. */
  function koordSchrift(zeilen, schrift) {
    const sch = schriftVon(schrift);
    return zeilen.every((z) => textInSchrift(z, sch)) ? sch : SCHRIFT_MODERN;
  }
  /* Zeile mit Mass m (breite/oben/unten) und optischer Mitte yMitte liegt im Herz minus TEXT_RAND */
  function zeileImHerz(m, gr, yMitte) {
    const basis = yMitte + gr * VERSAL / 2;
    const yo = basis - m.oben, yu = basis + m.unten;
    return herzRechteckPasst(CX, (yo + yu) / 2, m.breite, yu - yo);
  }
  function koordLayout(zeilen, sch, form) {
    if (form !== 'herz') {
      for (const gr of KOORD_STUFEN) if (zeilen.every((z) => zeilePasst(z, gr, FIT_BREITE.coin, sch))) return gr;
      return null;
    }
    for (const gr of KOORD_STUFEN) {
      const lh = gr * ZEILE_EM, n = zeilen.length;
      if (zeilen.every((z, i) => zeileImHerz(zeilenMass(z, gr, sch), gr, HERZ_CY + (i - (n - 1) / 2) * lh))) return gr;
    }
    return null;
  }
  function backKoordinaten(cfg) {
    const ort = cfg.rueck_ort;
    if (!ort || !isFinite(ort.lat) || !isFinite(ort.lon)) return SVG_LEER;
    const form = normForm(cfg);
    const zeilen = koordZeilen(ort);
    const sch = koordSchrift(zeilen, cfg.schrift);
    const gr = koordLayout(zeilen, sch, form);
    if (gr == null) throw new Error('jewelry-abdruck-engine: Koordinaten passen nicht auf den ' + (form === 'herz' ? 'Herz' : 'Coin'));
    const lh = gr * ZEILE_EM, cy = form === 'herz' ? HERZ_CY : CY;
    let s = SVG_KOPF + schriftDefs(sch, false);
    zeilen.forEach((z, i) => { s += zeile(z, gr, cy + (i - (zeilen.length - 1) / 2) * lh, sch); });
    return s + '</svg>';
  }
  /* Text-Motiv V6 (Dominik 21.10.: „keinen Line Break“, „der Platz wird nicht ausgenutzt“): eigene Zeilen per Enter
     (max. TEXT_ZEILEN_MAX, zu lange Zeilen brechen zusaetzlich an Wortgrenzen um), dann der groesste Schriftgrad, bei dem
     die TINTE jeder Zeile im Coin-Kreis minus 0,5 mm liegt (wie die Sternenhimmel-Rueckseite seit 11.10.). Breiten:
     'modern' aus der echten Metrik der Gravurschrift (jewelryTextTinte), die waehlbaren Schriften aus ihren
     gemessenen Vorschueben plus 3 % fuer ueberhaengende Schwuenge, Ober-/Unterlaengen aus ihrem Glyphenkasten. */
  const TEXT_ZEILEN_MAX = 4;
  const TEXT_GR_MAX = 160;
  const TEXT_RAND = 32;                      /* 0,5 mm auf 16 mm */
  const TEXT_R = 512 - TEXT_RAND;
  function textZeilenRoh(text) {
    return String(text == null ? '' : text).split(/\r?\n/).map((z) => z.trim().replace(/\s+/g, ' ')).filter(Boolean);
  }
  function zeilenMass(t, gr, sch) {
    if (!sch.kasten) {
      if (typeof w.jewelryTextTinte === 'function') return w.jewelryTextTinte(t, gr);
      return { breite: breiteIn(t, gr, SCHRIFT_MODERN), oben: KOPF_JOST * gr, unten: 0.23 * gr };
    }
    let oben = 0, unten = 0;
    for (const ch of t) {
      const k = sch.kasten[ch];
      if (k) { oben = Math.max(oben, k[1]); unten = Math.max(unten, -k[0]); }
    }
    return { breite: breiteIn(t, gr, sch) * 1.03, oben: oben * sch.skala * gr, unten: unten * sch.skala * gr };
  }
  function textUmbruch(roh, gr, sch) {
    const zeilen = [];
    for (const zeileRoh of roh) {
      let akt = '';
      for (const wort of zeileRoh.split(' ')) {
        if (zeilenMass(wort, gr, sch).breite > 2 * TEXT_R) return null;
        const test = akt ? akt + ' ' + wort : wort;
        if (zeilenMass(test, gr, sch).breite <= 2 * TEXT_R) akt = test;
        else { zeilen.push(akt); akt = wort; }
      }
      if (akt) zeilen.push(akt);
    }
    return zeilen.length <= TEXT_ZEILEN_MAX ? zeilen : null;
  }
  /* form 'herz' (PROJ-116): Block um HERZ_CY, jede Zeile gegen die Sehnenbreite des Herzens statt gegen den Coin-Kreis */
  function textLayout(text, sch, form) {
    const roh = textZeilenRoh(text);
    if (!roh.length || roh.length > TEXT_ZEILEN_MAX) return null;
    const herz = form === 'herz';
    const cy = herz ? HERZ_CY : CY;
    for (let gr = TEXT_GR_MAX; gr >= RUECK_MIN; gr -= 2) {
      const zeilen = textUmbruch(roh, gr, sch);
      if (!zeilen) continue;
      const lh = gr * ZEILE_EM, n = zeilen.length;
      let passt = true;
      const lagen = zeilen.map((z, i) => {
        const yMitte = cy + (i - (n - 1) / 2) * lh;
        const basis = yMitte + gr * VERSAL / 2;
        const m = zeilenMass(z, gr, sch);
        if (herz) {
          if (!zeileImHerz(m, gr, yMitte)) passt = false;
        } else {
          const dy = Math.max(Math.abs(basis - m.oben - CY), Math.abs(basis + m.unten - CY));
          if ((m.breite / 2) ** 2 + dy ** 2 > TEXT_R ** 2) passt = false;
        }
        return { z, yMitte };
      });
      if (passt) return { gr, lagen };
    }
    return null;
  }
  function textZuLang(text, schrift, form) {
    const roh = textZeilenRoh(text);
    if (!roh.length) return false;
    if ([...roh.join(' ')].length > RUECKSEITE_MAX || roh.length > TEXT_ZEILEN_MAX || !schriftOk(schrift)) return true;
    const sch = schriftVon(schrift);
    if (!textInSchrift(roh.join(' '), sch)) return true;
    return textLayout(text, sch, normForm({ form })) == null;
  }
  function backText(cfg) {
    const sch = schriftVon(cfg.schrift);
    const roh = textZeilenRoh(cfg.rueckseite);
    if (!roh.length) return SVG_LEER;
    if (!textInSchrift(roh.join(' '), sch)) throw new Error('jewelry-abdruck-engine: Rueckseite mit Zeichen ausserhalb der Schrift, vorher jewelryAbdruckTextZuLang aufrufen');
    const lay = textLayout(cfg.rueckseite, sch, normForm(cfg));
    if (!lay) throw new Error('jewelry-abdruck-engine: Rueckseiten-Text passt nicht, vorher jewelryAbdruckTextZuLang aufrufen');
    let s = SVG_KOPF + schriftDefs(sch, false);
    for (const l of lay.lagen) s += zeile(l.z, lay.gr, l.yMitte, sch);
    return s + '</svg>';
  }
  function backMotivSVG(cfg, motiv, extra) {
    if (motiv === 'text') return backText(cfg);
    if (motiv === 'keine') return SVG_LEER;
    const form = normForm(cfg);
    if (RUECK_MOTIVE_PFAD.indexOf(motiv) >= 0) {
      const d = extra && extra.d;
      if (d == null || d === '') return SVG_LEER;
      /* der Pfad ist schon in die Form eingepasst (Ausarbeitung auf dem Server bzw. Beispiel je Form) */
      return frontSVG({ form, gravur: cfg.rueck_gravur }, d);
    }
    if (motiv === 'blume') {
      if (typeof w.jewelryBlumenFrontSVG !== 'function') throw new Error('jewelryAbdruck: jewelry-blumen-engine.js nicht geladen');
      if (form !== 'herz') return w.jewelryBlumenFrontSVG({ monat: cfg.rueck_monat, blume: cfg.rueck_blume, name: '' });
      /* Herz: dieselbe Blume, contain-gefittet. Mitte = Mitte der gravierbaren Hoehe auf der Mittelachse (Kerbe y 118
         bis Spitze y 938 → 528), oben und unten gleich viel Luft (Dominik 24.10.: am Schwerpunkt 452 sass sie zu hoch).
         Die Breitenprobe rechnet mit dem echten Seitenverhaeltnis des Motivs (0,34 bis 0,58). */
      if (typeof w.jewelryBlumenMotivSVG !== 'function') throw new Error('jewelryAbdruck: jewelry-blumen-engine.js ohne jewelryBlumenMotivSVG');
      const bcfg = { monat: cfg.rueck_monat, blume: cfg.rueck_blume };
      const verh = typeof w.jewelryBlumenMotivVerhaeltnis === 'function' ? w.jewelryBlumenMotivVerhaeltnis(bcfg) : 0.58;
      const cy = (HERZ_Y_MIN + HERZ_Y_MAX) / 2;
      let box = 760;
      while (box > 200 && !herzRechteckPasst(CX, cy, box * verh, box)) box -= 5;
      return SVG_KOPF + w.jewelryBlumenMotivSVG(bcfg, CX, cy, box, box) + '</svg>';
    }
    if (motiv === 'sternenhimmel') {
      if (typeof w.jewelryFrontSVG !== 'function') throw new Error('jewelryAbdruck: jewelry-engine.js nicht geladen');
      const g = cfg.geburt || {};
      const ort = cfg.rueck_ort;
      if (!ort || !isFinite(ort.lat) || !isFinite(ort.lon) || !g.datum || !extra || !extra.sterne || !extra.linien) return SVG_LEER;
      return w.jewelryFrontSVG({ ort, datum: g.datum, zeit: g.zeit || null, stil: 'klassisch', form }, extra.sterne, extra.linien);
    }
    return backKoordinaten(cfg);
  }

  function backSVG(cfg, extra) {
    const motiv = rueckMotivVon(cfg);
    if (motiv) return backMotivSVG(cfg, motiv, extra);
    const sch = schriftVon(cfg && cfg.schrift);
    const geburt = !!(cfg && cfg.rueck_modus === 'geburt');
    let s = schriftDefs(sch, geburt);
    const form = normForm(cfg);
    const fit = FIT_BREITE[form];
    if (geburt) {
      return SVG_KOPF + s + backGeburt(cfg, form, sch) + '</svg>';
    }
    const t = normText(cfg && cfg.rueckseite);
    if (t) {
      if (!textInSchrift(t, sch)) throw new Error('jewelry-abdruck-engine: Rueckseite mit Zeichen ausserhalb der Schrift, vorher jewelryAbdruckRueckseiteZuLang aufrufen');
      const lay = rueckLayout(t, fit, sch);
      if (lay) {
        const lh = lay.gr * ZEILE_EM;
        const n = lay.zeilen.length;
        for (let i = 0; i < n; i++) {
          /* Blockmitte auf der Coin-/Herz-Mitte; Grundlinie je Zeile eine
             halbe Versalhoehe unter ihrer optischen Mitte. */
          const yMitte = CY + (i - (n - 1) / 2) * lh;
          const y = yMitte + lay.gr * VERSAL / 2;
          s += `<text x="${CX}" y="${y.toFixed(1)}" font-family="${sch.familie}" font-size="${groesseAttr(lay.gr, sch)}" text-anchor="middle" fill="${INK}">${esc(lay.zeilen[i])}</text>`;
        }
      }
    }
    return SVG_KOPF + s + '</svg>';
  }

  w.JEWELRY_ABDRUCK = Object.freeze({
    VERSION,
    MAX_PUNKTE,
    MAX_D_BYTES,
    GRAVUR_FLAECHE,
    GRAVUR_LINIEN,
    GRAVUREN: Object.freeze(GRAVUREN.slice()),
    LINIEN_BREITE,
    RUECKSEITE_MAX,
    BOGEN_MAX,
    NAME_MAX,
    FIT_BREITE: Object.freeze({ coin: FIT_BREITE.coin, herz: FIT_BREITE.herz }),
    FORMEN: Object.freeze(FORMEN.slice()),
    MOTIVE: Object.freeze(MOTIVE.slice()),
    RUECK_MODI: Object.freeze(RUECK_MODI.slice()),
    RUECK_MOTIVE: Object.freeze(RUECK_MOTIVE.slice()),
    RUECK_MOTIVE_PFAD: Object.freeze(RUECK_MOTIVE_PFAD.slice()),
    TEXT_ZEILEN_MAX,
    SCHRIFT_STANDARD,
  });
  w.jewelryAbdruckSchriftOk = schriftOk;
  w.jewelryAbdruckTextInSchrift = (t, schrift) => schriftOk(schrift) && textInSchrift(normText(t), schriftVon(schrift));
  w.jewelryAbdruckPfadOk = pfadOk;
  w.jewelryAbdruckFrontSVG = frontSVG;
  /* PROJ-107 (25.10.2026): Herz-Innenmass fuer die Schwester-Engines (Geburtsblume als Herz), nur lesend. */
  w.jewelryHerzBreite = herzBreite;
  w.jewelryHerzRechteckPasst = herzRechteckPasst;
  w.jewelryAbdruckBackSVG = backSVG;
  w.jewelryAbdruckRueckseiteZuLang = rueckseiteZuLang;
  w.jewelryAbdruckBogenZuLang = bogenZuLang;
  w.jewelryAbdruckRingZuLang = ringZuLang;
  w.jewelryAbdruckNameZuLang = nameZuLang;
  w.jewelryAbdruckKoordZeilen = koordZeilen;
  w.jewelryAbdruckTextZuLang = textZuLang;
  w.jewelryAbdruckKoordinatenZuLang = (ort, schrift, form) => { const z = koordZeilen(ort); return koordLayout(z, koordSchrift(z, schrift), normForm({ form })) == null; };
})(window);
